module.exports = __webpack_public_path__ + "img/solar-panel-solid.f7e38842.svg";